<!-- 批量上传面单 -->
<template>
<el-dialog :title="msg('批量上传面单')" 
    :visible.sync="visible" 
    :fullscreen="isMinScreen" 
    :close-on-click-modal="false" 
    width="600px"
>
    <div class="content-panel">
        <el-row :gutter="10" type="flex" justify="space-between" align="middle" class="breadcrumb-wrap">
            <el-col :span="20">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/' }">{{msg('首页')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{msg('批量上传面单')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>

        <el-row :gutter="10" type="flex" justify="space-between" align="center" class="ctrl-wrap">
            <el-col :span="8">
                <el-upload class="upload-demo" :with-credentials="true" multiple
                    ref="upload"
                    :file-list="fileList"
                    :before-upload="handleBeforeUpload"
                    :data="pdfdata"
                    :limit="50"
                    :on-exceed="handleOnExceed"
                    :action="pageImport" 
                    :on-success="handleSuccess"
                    >
                    <el-button size="small" icon="el-icon-upload2" type="primary">{{msg('批量上传面单')}}</el-button>
                </el-upload>
            </el-col>
            <el-col :span="6">
                <el-button size="small" icon="el-icon-upload2" type="success" @click="clearRes">{{msg('清空结果')}}</el-button>
            </el-col>
            <el-col :span="8" v-if="showLink">
                <el-link @click="showMore" style="margin-top:10px;">更多...</el-link>
            </el-col>
            <el-col :span="8" v-show="hasPermission('stock:pageImport1') && showButton">
                <el-upload class="upload-demo" :with-credentials="true" multiple
                    :file-list="fileList1"
                    :before-upload="handleBeforeUpload1"
                    :data="pdfdata1"
                    :limit="100"
                    :on-exceed="handleOnExceed1"
                    :action="pageImport1" :on-success="handleSuccess1">
                    <el-button size="small" icon="el-icon-download" type="danger">{{msg('上传面单原件（慎用）')}}</el-button>
                </el-upload>
            </el-col>
        </el-row>
    
        <div class="table-wrap">
            <el-table :data="results" style="width: 100%" height="400px" size="mini" ref="dataTable" stripe>
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column prop="filename" :label="msg('文件名')" min-width="120" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="ordercode" :label="msg('订单编号')" min-width="120" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="msg" :label="msg('上传结果')" min-width="200"></el-table-column>
            </el-table>
        </div>
        <el-row :gutter="10" type="flex" justify="start" align="center" class="ctrl-wrap">
            <el-col :span="24">
                <el-alert :title="msg('stock-page-warning1')"  type="warning"></el-alert>
                <el-alert :title="msg('stock-page-warning2')"  type="warning"></el-alert>
                <el-alert :title="msg('stock-page-warning3')"  type="warning"></el-alert>
            </el-col>
        </el-row>
    </div>
</el-dialog>
</template> 

<script>

export default {
    name: 'StockPageImport',
    components: {},
    mounted:function(){
    },
    data(){
      return{
        visible: false,
        showLink:true,
        showButton:false,
        pageImport: this.$kit.api.stock.pageImport,
        pageImport1: this.$kit.api.stock.pageImport1,
        results: [],   //表格数据列表
        fileList: [],
        fileList1: [],
        pdfdata:{
          code:null,
          pwd:null,
        },
        pdfdata1:{
          code:null
        },
      }
    }, 
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                return this.$store.state.isMinScreen;
            }
        }
    },
    methods: {
        showDialog(){
            this.visible = true;
            this.showLink = true;
            this.showButton = false;
            this.results.splice(0);
            this.fileList.splice(0);
            this.fileList1.splice(0);
        },
        showMore(){
            this.showButton = true;
            this.showLink = false;
            setTimeout(() => {
                this.showButton = false;
                this.showLink = true;
            }, 1000);
        },
        clearRes(){
            this.results.splice(0);
            this.fileList.splice(0);
            this.fileList1.splice(0);
        },
        handleSuccess(res, file, fileList) {
            if(res.status){
                var data = res.data;
                this.results.push(data);
            }else{
                this.$message(res.msg || this.msg("上传失败"));
            }
        },
        handleSuccess1(res, file, fileList) {
            if(res.status){
                var data = res.data;
                this.results.push(data);
            }else{
              this.$message(res.msg || this.msg("上传失败"));
            }
        },
        handleOnExceed(files, fileList){
            this.$message(this.msg("提示：请【清空结果】后再上传，单次上传不能大于50个文件"));
            return false;
        },
        handleOnExceed1(files, fileList){
            this.$message(this.msg("提示：请【清空结果】后再上传，单次上传不能大于50个文件"));
            return false;
        },
        handleBeforeUpload(file,fileList){
            var filename = file.name;
            var name = filename.substring(0, filename.lastIndexOf("."));

            var temps = name.split("+");

            let codeName = temps[0].replace(/\s+/g, "");
            // name = name.replace(/\s+/g, "");

            if(!/[\u4E00-\u9FA5]+/g.test(codeName)){
                this.pdfdata.code= codeName;
                if(temps.length>1){
                    let pwd = temps[1].replace(/\s+/g, "");
                    if(!/[\u4E00-\u9FA5]+/g.test(codeName)){
                        this.pdfdata.pwd = temps[1];
                    }else{
                        this.$message(this.msg("文件名的单号不合法"));
                        return false;
                    }
                }
                return true;
            }else{
                this.$message(this.msg("文件名的单号不合法"));
                return false;
            }
        },
        handleBeforeUpload1(file){
            var filename = file.name;
            var name = filename.substring(0, filename.lastIndexOf("."));
            name = name.replace(/\s+/g, "");

            if(!/[\u4E00-\u9FA5]+/g.test(name)){
                this.pdfdata1.code= name;
                return true;
            }else{
                this.$message(this.msg("文件名的单号不合法"));
                return false;
          }
      }
    }
}
</script>

<style scoped lang="scss">


</style>
